import type { Application } from "~/types/userObject";

export interface ApplicationsResponse {
	data: Application[];
	current_page: number;
	last_page: number;
}

export type AtsApplicationPayload = {
	companySlug?: string;
	jobSlug: string | Record<string, string>;
	jobId: number;
	xsrf: string;
	token: string;
};

export class ApplicationsRepository {
	private baseUrl = globalConfig.API + "/profile/applications";
	private applicationIdsUrl = globalConfig.API + "/profile/application-ids";

	async getApplications(page = 1, perPage = 15): Promise<ApplicationsResponse> {
		const token = useAuth.getToken();
		const url = new URL(this.baseUrl);
		url.searchParams.append("page", String(page));
		url.searchParams.append("per_page", String(perPage));

		try {
			return await $fetch<ApplicationsResponse>(url.href, {
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
		} catch (err) {
			showError({ statusCode: 500, message: "ApplicationsRepository.getApplications error" });
			throw err;
		}
	}

	async getApplicationIds(): Promise<number[]> {
		const token = useAuth.getToken();

		try {
			const response = await $fetch<{ application_ids?: number[] } | number[]>(this.applicationIdsUrl, {
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
			if (Array.isArray(response)) return response;
			return Array.isArray(response?.application_ids) ? response.application_ids : [];
		} catch (err) {
			console.error("ApplicationsRepository.getApplicationIds error");
			return [];
		}
	}

	async submit(formData: FormData): Promise<{ success: boolean }> {
		return await $fetch<{ success: boolean }>("/api/application", {
			method: "POST",
			body: formData,
		});
	}

	async storeAts(body: AtsApplicationPayload) {
		return await $fetch("/api/ats-application", {
			method: "POST",
			body,
		});
	}
}
